<template>
    <div class="dialog_area">
        <div class="input_group">
            <div class="alert_box">
                <p>同じメールアドレス、または同じ電話番号で、このチャットボットに2回以上申込まれた場合の扱いを設定します。</p>
                <p>「受け付けない」にすると、既に申込済みのメールアドレス・電話番号は入力時と申込送信時に弾かれ、申込者リスト・スプレッドシート連携・自動返信メールにも重複が入りません。</p>
                <p>電話番号はハイフン・空白の有無を区別せずに比べます。同じ会社の代表番号を複数の方が入力する場合も重複として扱われます。</p>
            </div>
        </div>
        <div class="input_group">
            <div class="input_box">
                <div class="label">同じメールアドレス・電話番号での重複申込</div>
                <label class="radio">
                    <input type="radio" :value="false" v-model="allowDuplicateEmail" />
                    受け付けない（初期設定）
                </label>
                <label class="radio">
                    <input type="radio" :value="true" v-model="allowDuplicateEmail" />
                    受け付ける
                </label>
            </div>
            <div class="input_box">
                <label>
                    <div class="label">重複時にチャットボットへ表示する文言</div>
                    <textarea v-model="duplicateEmailMessage" :disabled="allowDuplicateEmail" rows="3"
                        :placeholder="defaultMessage"></textarea>
                    <div class="hint">空欄の場合は、メールアドレスの重複は「{{ defaultMessage }}」、電話番号の重複は「{{ defaultTelMessage }}」と表示します。入力した場合は、どちらの重複にもこの文言を表示します。</div>
                </label>
            </div>
            <div class="input_box">
                <button class="ok" :disabled="!loaded" @click.stop="btnOk">保存する</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Api from '@/lib/Api.js'

export default {
    name: 'dialogDuplicate',
    props: ['id'],
    components: {
    },
    data() {
        return {
            loaded: false,
            allowDuplicateEmail: false,
            duplicateEmailMessage: '',
            // backend/src/logic/logicChatbot.php の DEFAULT_DUPLICATE_EMAIL_MESSAGE / DEFAULT_DUPLICATE_TEL_MESSAGE と同じ文言
            defaultMessage: 'このメールアドレスでは既にお申し込みいただいております。',
            defaultTelMessage: 'この電話番号では既にお申し込みいただいております。',
        }
    },
    computed: {
        ...mapGetters({
            scenario_id: 'scenario/id',
        })
    },
    created: async function () {
        let response = await Api.scenarioGet(this, this.scenario_id)
        let s = response.data
        this.allowDuplicateEmail = s.allowDuplicateEmail === true
        this.duplicateEmailMessage = s.duplicateEmailMessage || ''
        this.loaded = true
    },
    methods: {
        async btnOk() {
            let response = await Api.updateDuplicate(this, {
                'id': this.scenario_id,
                'allowDuplicateEmail': this.allowDuplicateEmail,
                'duplicateEmailMessage': this.duplicateEmailMessage,
            })
            if (response.login_status == "LOGGED_IN" && response.status == "OK") {
                alert('重複登録設定を保存しました')
            } else {
                alert('重複登録設定を保存できませんでした')
            }
        },
    },
}
</script>

<style scoped>
.dialog_area {
    position: relative;
    width: calc(100% - 30px);
    margin: 0 15px;
    background-color: white;
    height: 100%;
    top: 0;
    left: 0;
    overflow: auto;
    z-index: 3;
    padding: 0;
    text-align: left;
}

.ok {
    box-sizing: border-box;
    border: 1px solid #00bcd4;
    line-height: 20px;
    background-color: #00bcd4;
    color: white;
    padding: 5px 20px;
    border-radius: 4px;
    font-weight: 700;
}

.ok:hover {
    background-color: white;
    color: #00bcd4;
}

.ok:disabled {
    border: 1px solid gray;
    background-color: #008a9c;
    color: #c0c0c0;
}

.input_group {
    margin-left: 30px;
    margin-right: 30px;
}

.input_box {
    margin-bottom: 30px;
}

.label {
    font-weight: 700;
    margin-bottom: 8px;
}

.radio {
    display: block;
    margin: 6px 0;
    cursor: pointer;
}

textarea {
    box-sizing: border-box;
    width: 100%;
    max-width: 640px;
    font-size: 15px;
    padding: 6px;
    resize: vertical;
}

.hint {
    color: #666;
    font-size: 13px;
    margin-top: 4px;
}

.alert_box {
    box-sizing: border-box;
    background-color: #e0f4f8;
    border-radius: 10px;
    margin: 30px 0;
    padding: 20px 30px;
    width: 100%;
}
</style>
